import { createReduxHistoryContext } from "redux-first-history";

import { createBrowserHistory } from "history";

export const { createReduxHistory, routerReducer, routerMiddleware } =
  createReduxHistoryContext({
    basename: process.env.NODE_ENV !== "test" ? "/my-account" : "",
    history: createBrowserHistory(),
  });
